import { createBrowserRouter, Navigate } from 'react-router-dom';
import { PortalShell } from '@/components/PortalShell';
import { AssemblyPage } from '@/pages/AssemblyPage';
import { ForecastPage } from '@/pages/ForecastPage';
import { HomePage } from '@/pages/HomePage';
import { SettingsPage } from '@/pages/SettingsPage';

/**
 * Routen des Partnerportals (ADR 0085). Bewusst wenige — das Portal zeigt
 * genau die Sichten, die ein Partner braucht, und sonst nichts.
 */
export const router = createBrowserRouter([
  {
    path: '/',
    element: <PortalShell />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'bedarfsvorschau', element: <ForecastPage /> },
      { path: 'montagen', element: <AssemblyPage /> },
      { path: 'einstellungen', element: <SettingsPage /> },
      // Unbekannte Pfade zurück auf die Übersicht — im Portal gibt es nichts,
      // wofür sich eine eigene 404-Seite lohnen würde.
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
